"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DateTimePickerView;
(function (DateTimePickerView) {
    DateTimePickerView["YEAR"] = "year";
    DateTimePickerView["DATE"] = "date";
    DateTimePickerView["HOUR"] = "hours";
    DateTimePickerView["MINUTES"] = "minutes";
})(DateTimePickerView || (DateTimePickerView = {}));
exports.default = DateTimePickerView;
